<template>
  <modal
    class="z-top"
    :open="open"
    @close="$emit('close')"
  >
    <template v-slot:trigger="triggerSlotProps">
      <button
        type="button"
        class="absolute top-0 right-0 flex items-center justify-center text-gray-400 hover:text-gray-600 w-10 h-10 z-10"
        @click.self="$emit('close')"
      >
        <span class="sr-only">Close</span>
        <svg
          class="w-4 h-4 pointer-events-none"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"
          ></path>
        </svg>
      </button>
    </template>

    <template v-slot:default="defaultSlotProps">
      <div class="bg-white fade-in">
        <div class="block border-b text-lg leading-tight pl-6 pr-10 py-4">
          Log in or create an account for free sample shipping
        </div>

        <form
          method="post"
          :action="route('login')"
        >
          <input
            type="hidden"
            name="_token"
            :value="csrf"
          />

          <input
            type="hidden"
            name="redirectTo"
            :value="redirectTo"
          />

          <div class="px-6 pt-2">
            <div class="relative mt-4 mb-4 appearance-none label-floating">
              <input
                type="email"
                id="login-email"
                name="email"
                class="w-full bg-gray-100 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                placeholder=" "
                required
                autocomplete="username"
              />
              <label
                class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                for="login-email"
              >
                Email
              </label>
            </div>

            <div class="relative mt-4 appearance-none label-floating">
              <input
                type="password"
                id="login-password"
                name="password"
                class="w-full bg-gray-100 border-b border-gray-300 focus:border-black py-4 px-3 text-gray-900 leading-normal focus:outline-none"
                placeholder=" "
                required
                autocomplete="current-password"
              />
              <label
                class="absolute block text-gray-500 top-0 left-0 w-full px-3 py-4 leading-normal"
                for="login-password"
              >
                Password
              </label>
            </div>

            <div class="flex flex-wrap justify-between">
              <label
                for="login-remember"
                class="flex items-center mt-3"
              >
                <input
                  type="checkbox"
                  id="login-remember"
                  name="remember"
                />
                <span class="pl-2">Remember Me</span>
              </label>
              <a
                class="text-sm hover:underline mt-3"
                :href="route('password.request')"
                >Forgot your password?</a
              >
            </div>
          </div>

          <div class="flex flex-wrap px-4 pb-4 mt-2">
            <div class="w-1/2 min-w-56 flex-grow px-2 pt-2">
              <button
                type="submit"
                class="button button--primary w-full h-14 p-0"
              >
                <span>Sign In</span>
              </button>
            </div>
            <div class="w-1/2 min-w-56 flex-grow"></div>
          </div>
        </form>

        <div class="flex flex-wrap border-t px-4 pt-2 pb-4">
          <div class="w-1/2 min-w-56 flex-grow px-2 pt-2">
            <a
              :href="route('account.register')"
              class="button button--primary-outline flex items-center justify-center w-full h-14 p-0"
            >
              Register
            </a>
          </div>
          <div class="w-1/2 min-w-56 flex-grow px-2 pt-2">
            <button
              type="button"
              class="button flex items-center justify-center w-full h-14 bg-gray-200 hover:bg-gray-300 text-gray-800 hover:text-gray-900 whitespace-nowrap p-0"
              @click.self="$root.continueAsGuest($emit('close'))"
            >
              Continue as Guest
            </button>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from "@components/Common/Modal";
  import HasRoutes from "@/mixins/HasRoutes";

  export default {
    name: "PromptLoginModal",

    components: {
      Modal,
    },

    mixins: [HasRoutes],

    props: {
      open: {
        default: false,
        type: Boolean,
      },
    },

    data() {
      return {
        csrf: document.head.querySelector('meta[name="csrf-token"]').content,
      };
    },

    computed: {
      redirectTo() {
        return window.location.pathname;
      },
    },
  };
</script>
